import { getApolloClient } from '@faustwp/core';
import { BlogListPage } from '../../components/BlogListPage';
import { fetchBlogListData } from '../../lib/blogUtils';
import { getBaseCategoryForLang } from '../../constants/blogCategories';

export default function BlogIndexPage({ posts, generalSettings, useAcfQuery }) {
  return (
    <BlogListPage
      posts={posts}
      generalSettings={generalSettings}
      lang="en"
      basePath="/blog"
      useAcfQuery={useAcfQuery}
    />
  );
}

export async function getStaticProps() {
  try {
    const client = getApolloClient();
    const baseCategory = getBaseCategoryForLang('en');
    const variables = { categorySlug: baseCategory, first: 200 };
    const { posts, generalSettings, useAcfQuery } = await fetchBlogListData(client, variables, { lang: 'en' });
    return {
      props: { posts: posts ?? [], generalSettings: generalSettings ?? null, useAcfQuery: useAcfQuery ?? false },
      revalidate: 60,
    };
  } catch (err) {
    console.error('[blog/index] getStaticProps failed', err);
    return {
      props: { posts: [], generalSettings: null, useAcfQuery: false },
      revalidate: 60,
    };
  }
}
